import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

export default class tableCostCenterView extends JetView {
    /**
     * Configures the datatable view for cost centers.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        return {
            view: 'datatable', // Type of view
            id: 'datatable', // Unique identifier for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            columns: [
                // Column definitions
                {
                    id: 'rating', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: _('Editar'), // Tooltip text
                    template: function(obj) {
                        // Template function for rendering
                        if (devConfig.getPermAction('accountingCostCenterEdit', 'Edit')) {
                            return '<span class=\'webix_icon wxi-close edit\'></span>'; // Edit icon if permission granted
                        } else {
                            return ''; // No icon if permission denied
                        }
                    },
                },
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                { id: 'Name', header: _('Nombre'), width: 150, sort: 'int' }, // Name column
                { id: 'Code', header: _('Código'), width: 150, sort: 'int' }, // Code column
                {
                    id: 'State', // State column
                    header: _('Estado'), // Header text
                    editor: 'combo', // Editor type
                    options: [
                        // Options for the combo editor
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'TypeCenter', // TypeCenter column
                    header: _('Tipo de Centro'), // Header text
                    width: 150, // Column width
                    sort: 'int', // Sorting type
                },
            ],
            onClick: {
                // Event handler for click events
                edit: function(euv, id) {
                    // Edit action
                    vthis.app.callEvent('openEdit', [{}]); // Trigger edit event
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'Accounting/GetCostCenter', // Data source URL
        };
    }

    /**
     * Initializes the datatable and its associated components.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var url = grid.data.url; // Data URL
        var filter = ''; // Filter variable
        var datePopup = []; // Array for date popup data
        var popup = ''; // Variable for edit popup
        var popupAdd = ''; // Variable for add popup

        webix
            .ajax() // AJAX request to fetch data
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(
                devConfig.geturlApi() + 'Accounting/GetTypesCenterPositionSelect', // API endpoint
                '{"Type":0}', // Request body
                {
                    error: function(text, data, XmlHttpRequest) {
                        // Error handler
                        webix.message('Error! '); // Show error message
                    },
                    success: function(text, data, XmlHttpRequest) {
                        // Success handler
                        var resp = JSON.parse(text); // Parse response
                        datePopup = resp.Data; // Store data for popup
                        popup = webix.ui({
                            // Create edit popup
                            view: 'window',
                            id: 'EditCenter',
                            head: {
                                view: 'toolbar',
                                cols: [
                                    {
                                        view: 'label',
                                        label: _('Editar Centro'), // Popup title
                                    },
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close', // Close icon
                                        click: function() {
                                            this.getTopParentView().hide(); // Hide popup on close
                                        },
                                    },
                                ],
                            },
                            position: 'center', // Center position
                            modal: true, // Modal window
                            body: {
                                view: 'form', // Form inside the popup
                                id: 'editForm', // Form ID
                                elements: [
                                    // Form elements
                                    {
                                        view: 'text',
                                        label: 'ID',
                                        name: 'Id',
                                        readonly: true, // Read-only field
                                    },
                                    {
                                        view: 'text',
                                        label: _('Nombre'),
                                        name: 'Name', // Name field
                                    },
                                    {
                                        view: 'text',
                                        label: _('Código'),
                                        name: 'Code',
                                        readonly: true, // Read-only field
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Estado'),
                                        name: 'IsActivate', // Activation state field
                                        options: [
                                            { id: 'A', value: _('Activado') },
                                            { id: 'I', value: _('Inactivado') },
                                        ],
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Tipo de Centro'),
                                        name: 'TypeCenter',
                                        readonly: true, // Read-only field
                                        labelWidth: 120, // Label width
                                    },
                                    {
                                        cols: [
                                            // Button layout
                                            {
                                                view: 'button',
                                                value: _('Cancelar'), // Cancel button
                                                click: function() {
                                                    this.getTopParentView().hide(); // Hide popup on cancel
                                                    $$('editForm').setValues(
                                                        $$('editForm').getCleanValues(), // Reset form values
                                                    );
                                                },
                                            },
                                            {
                                                view: 'button',
                                                type: 'form',
                                                value: _('Guardar'), // Save button
                                                click: function($e) {
                                                    var values = $$('editForm').getValues(); // Get form values
                                                    webix
                                                        .ajax() // AJAX request to save data
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Accounting/CostCenter', // API endpoint
                                                            '{"Id":"' +
                                                            values.Id +
                                                            '", "Name":"' +
                                                            values.Name +
                                                            '", "Code":"' +
                                                            values.Code +
                                                            '", "IsActivate":"' +
                                                            values.IsActivate +
                                                            '"  ,"TypeCenter":"' +
                                                            values.TypeCenter +
                                                            '"}', // Request body
                                                            {
                                                                error: function(text, data, XmlHttpRequest) {
                                                                    // Error handler
                                                                    webix.message(
                                                                        _('Error! '), // Show error message
                                                                    );
                                                                },
                                                                success: function(text, data, XmlHttpRequest) {
                                                                    // Success handler
                                                                    webix.message(
                                                                        _(
                                                                            'Centro Actualizado', // Show success message
                                                                        ),
                                                                    );
                                                                    grid.clearAll(); // Clear grid data
                                                                    grid.load(
                                                                        url +
                                                                        '?start=0&count=' +
                                                                        grid.data.$pagesize +
                                                                        filter, // Reload grid data
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    $$('editForm').setValues(
                                                        $$('editForm').getCleanValues(), // Reset form values
                                                    );
                                                    this.getTopParentView().hide(); // Hide popup after save
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        });
                        $$('editForm').bind($$('datatable')); // Bind form to datatable
                        popupAdd = webix.ui({
                            // Create add popup
                            view: 'window',
                            id: 'AddCenter',
                            head: {
                                view: 'toolbar',
                                cols: [
                                    {
                                        view: 'label',
                                        label: _('Añadir Centro'), // Popup title
                                    },
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close', // Close icon
                                        click: function() {
                                            this.getTopParentView().hide(); // Hide popup on close
                                        },
                                    },
                                ],
                            },
                            position: 'center', // Center position
                            modal: true, // Modal window
                            body: {
                                view: 'form',
                                id: 'addform',
                                elements: [
                                    {
                                        /** Text input for the name of the cost center. */
                                        view: 'text',
                                        label: _('Nombre'),
                                        name: 'Name',
                                        required: true,
                                        labelWidth: 100,
                                    },
                                    {
                                        /** Text input for the code of the cost center. */
                                        view: 'text',
                                        label: _('Código'),
                                        name: 'Code',
                                        required: true,
                                        labelWidth: 100,
                                    },
                                    {
                                        /** Combo box for selecting the activation state of the cost center. */
                                        view: 'combo',
                                        label: _('Estado'),
                                        name: 'IsActivate',
                                        required: true,
                                        labelWidth: 100,
                                        options: [
                                            { id: 'A', value: _('Activado') },
                                            { id: 'I', value: _('Inactivado') },
                                        ],
                                    },
                                    {
                                        /** Combo box for selecting the type of center. */
                                        view: 'combo',
                                        label: _('Tipo de Centro'),
                                        name: 'TypeCenter',
                                        options: datePopup,
                                        required: true,
                                        labelWidth: 140,
                                    },
                                    {
                                        /** Container for action buttons (Cancel and Save). */
                                        cols: [
                                            {
                                                /** Button to cancel the form and hide the popup. */
                                                view: 'button',
                                                value: _('Cancelar'),
                                                click: function() {
                                                    this.getTopParentView().hide();
                                                    $$('addform').setValues($$('addform').getCleanValues());
                                                },
                                            },
                                            {
                                                /** Button to save the form data. */
                                                view: 'button',
                                                type: 'form',
                                                value: _('Guardar'),
                                                click: function($e) {
                                                    var values = $$('addform').getValues();
                                                    if ($$('addform').validate()) {
                                                        /**
                                                         * Sends a POST request to save the cost center data.
                                                         */
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json',
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() + 'Accounting/SaveCostCenter',
                                                                '{"Name":"' +
                                                                values.Name +
                                                                '", "Code":"' +
                                                                values.Code +
                                                                '", "State":"' +
                                                                values.IsActivate +
                                                                '" ,"TypeCenter":"' +
                                                                values.TypeCenter +
                                                                '"}',
                                                                {
                                                                    /** Handles error response from the server. */
                                                                    error: function(text, data, XmlHttpRequest) {
                                                                        webix.message(_('Error! '));
                                                                    },
                                                                    /** Handles successful response from the server. */
                                                                    success: function(text, data, XmlHttpRequest) {
                                                                        webix.message(_('Centro Agregado'));
                                                                        grid.clearAll();
                                                                        grid.load(
                                                                            url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter,
                                                                        );
                                                                    },
                                                                },
                                                            );
                                                        $$('addform').setValues($$('addform').getCleanValues());
                                                        this.getTopParentView().hide();
                                                    } else {
                                                        /** Displays an error message if validation fails. */
                                                        webix.message({
                                                            title: _('¡Error!'),
                                                            type: 'alert-error',
                                                            text: _('Completa los campos...'),
                                                        });
                                                    }
                                                },
                                            },
                                        ],
                                    },
                                ],
                                /** Configuration for form elements. */
                                elementsConfig: {
                                    on: {
                                        /** Validates the form on change of any element. */
                                        onChange: function() {
                                            this.validate();
                                        },
                                    },
                                },
                            },
                        });
                    },
                });

        /**
         * Event listener for filtering cost centers based on filter data.
         */
        this.on(this.app, 'costCenter:filter', (filterData) => {
            var object = Object.entries(filterData);
            var string1 = '';
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - ');
                            string1 = string1 + '&dateFrom2=' + date[0];
                            string1 = string1 + '&dateTo2=' + date[1];
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll();
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1;
        });

        /**
         * Event listener for sorting the grid after a sort action.
         */
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir,
            );
        });

        /**
         * Event listener for adding a cost center when the button is clicked.
         */
        this.on(this.app, 'addCostCenter:button', (filter) => {
            if (datePopup.length > 0) {
                $$('addform').clearValidation();
                popupAdd.show();
            } else {
                /** Displays an error message if data could not be loaded. */
                webix.message({
                    text: _('Datos no han podido ser cargados'),
                    title: _('¡Error!'),
                    type: 'alert-error',
                });
            }
        });

        /**
         * Event listener for opening the edit popup for a cost center.
         */
        this.on(this.app, 'openEdit', (filterData) => {
            if (datePopup.length > 0) {
                popup.show();
            } else {
                /** Displays an error message if data could not be loaded. */
                webix.message({
                    text: _('Datos no han podido ser cargados'),
                    title: _('¡Error!'),
                    type: 'alert-error',
                });
            }
        });


    }
}

// FILE DOCUMENTED
